const HOST_NAMES = [
  [/youtube\.com|youtu\.be/i, "YouTube"],
  [/vimeo\.com/i, "Vimeo"],
  [/wistia\.(com|net)/i, "Wistia"],
  [/dailymotion\.com/i, "Dailymotion"],
  [/loom\.com/i, "Loom"],
  [/vidyard\.com/i, "Vidyard"],
  [/soundcloud\.com/i, "SoundCloud"],
  [/spotify\.com/i, "Spotify"],
  [/giphy\.com/i, "GIPHY"],
  [/tenor\.com/i, "Tenor"],
  [/unsplash\.com/i, "Unsplash"],
];

const DEFAULTS = {
  blocked_video: "Video blocked",
  blocked_audio: "Audio blocked",
  blocked_image: "Image blocked",
  blocked_content: "Content blocked",
  hint_video: "This video needs cookies from {{host}}. Without them, the video cannot play.",
  hint_audio: "This audio needs cookies from {{host}}. Without them, the audio cannot play.",
  hint_image: "This image is loaded from {{host}}, which needs cookies. Without them, the image cannot be shown.",
  hint_content: "This content needs cookies from {{host}}. Without them, it cannot be shown.",
  steps_title_video: "To view this video:",
  steps_title_audio: "To play this audio:",
  steps_title_image: "To view this image:",
  steps_title_content: "To view this content:",
  step_settings: "Click “{{settings_button}}”.",
  step_accept: "In the popup, click “{{accept_all}}”.",
  step_play: "Press play.",
  host_fallback_video: "the video provider",
  host_fallback_audio: "the audio provider",
  host_fallback_web: "an external website",
  settings_button: "Cookie settings",
  accept_all: "Accept all",
};

export const BLOCKED_ICON_MARKUP = {
  video: '<rect x="2" y="6" width="14" height="12" rx="2"/><path d="M16 10.5L22 7V17L16 13.5"/>',
  audio: '<path d="M9 18V5L21 3V16"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/>',
  image: '<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15L16 10L5 21"/>',
  content: '<rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 9H22M6 6.5H6.01M9 6.5H9.01"/>',
};

export const hostName = (url) => {
  if (!url) return null;
  const known = HOST_NAMES.find(([pattern]) => pattern.test(url));
  if (known) return known[1];
  try {
    return new URL(url, window.location.href).hostname.replace(/^www\./, "") || null;
  } catch (err) {
    return null;
  }
};

const fill = (text, values) =>
  String(text || "").replace(/\{\{\s*([a-z_]+)\s*\}\}/g, (match, key) => values[key] ?? match);

export const blockedContentCopy = (consent, contentType, sourceUrl) => {
  const kind = ["video", "audio", "image"].includes(contentType) ? contentType : "content";
  const text = (key) => consent?.[key] || DEFAULTS[key];
  const fallbackKey = kind === "video" || kind === "audio" ? `host_fallback_${kind}` : "host_fallback_web";
  const values = {
    host: hostName(sourceUrl) || text(fallbackKey),
    settings_button: text("settings_button"),
    accept_all: text("accept_all"),
  };
  const steps = [text("step_settings"), text("step_accept")];
  if (kind === "video" || kind === "audio") steps.push(text("step_play"));
  return {
    kind,
    title: text(`blocked_${kind}`),
    hint: fill(text(`hint_${kind}`), values),
    stepsTitle: text(`steps_title_${kind}`),
    steps: steps.map((step) => fill(step, values)),
    button: values.settings_button,
  };
};
